import React, { useEffect, useState } from 'react'
import { IStudentCourceDetail } from '../../../../../models/student/studentCourceDetail'
import { Chart as ChartJS } from 'chart.js';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Chart } from "primereact/chart";
import { connect } from "react-redux";
import { setStudentCourceDetail } from '../../../../../store/slices/student/studentCourceDetailSlice';
import { ROUTER_URL } from '../../../../../constants/routerUrl';
import { getStudentCourceDetail } from '../../../../../action/student/studentCourceDetailActionCreator';
import ChartDataLabels from 'chartjs-plugin-datalabels';

const BetaStudentCourseDetails = (props: IStudentCourceDetail) => {
  const { getCourceDetail, studentCourceDetail } = props;
  const [chartData, setChartData] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    getCourceDetail(1);
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setStudentCourceDetail([]));
    };
  }, []);

  const handleViewPage = () => {
    navigate(ROUTER_URL.STUDENT_COURSES);
  };

  useEffect(() => {
    if (studentCourceDetail) {
      setChartData({
        datasets: [
          {
            label: "Semester ",
            backgroundColor: ["#13c4fc", "#ddd"],
            data: [studentCourceDetail?.semesterPercentage, 100 - studentCourceDetail?.semesterPercentage],
          },
          {
            label: "Courses ",
            backgroundColor: ["#f57c7c", "#ddd"],
            data: [studentCourceDetail?.coursesPercentage, 100 - studentCourceDetail?.coursesPercentage],
          },
          {
            label: "Credit ",
            backgroundColor: ["#0262fe", "#ddd"],
            data: [studentCourceDetail?.creditsPercentage, 100 - studentCourceDetail?.creditsPercentage],
          },
        ],
      });
    }
  }, [studentCourceDetail]);

  const centerTextPlugin = {
    id: "centerText",
    beforeDraw: (chart: ChartJS) => {
      const { width, height, ctx } = chart;
      ctx.restore();
      const fontSize = (height / 300).toFixed(2);
      ctx.font = fontSize + "em sans-serif";
      ctx.textBaseline = "hanging";
      ctx.textAlign = "center";

      const text1 = "Overall";
      const text2 = "Progress";

      const textX = width / 2;
      const textY = height / 2 - 10;

      ctx.fillText(text1, textX, textY);
      ctx.fillText(text2, textX, textY + 15);
      ctx.save();
    },
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "30%",
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            const label = tooltipItem.dataset.label || '';
            const value = tooltipItem.raw;
            return label + ': ' + value + '%';
          },
        },
        filter: function (tooltipItem: any) {
          return tooltipItem.dataIndex === 0;
        },
        displayColors: false,
        backgroundColor: function (context: any) {
          const backgroundColors = [
            "#13c4fc",
            "#f57c7c",
            "#0262fe",
          ];
          return backgroundColors[context.tooltip.dataPoints[0].datasetIndex] || '#000';
        }
      },
      legend: {
        position: "top",
        labels: {
          usePointStyle: true,
        },
      },
      datalabels: {
        align: 'center',
        color: 'white',
        font: {
          weight: 'bold',
          size: 9,
        },
        formatter: (value: number, context: any) => {
          if (context.datasetIndex === 0 && value !== 100 - studentCourceDetail?.semesterPercentage) {
            return `${value}%`;
          }
          if (context.datasetIndex === 1 && value !== 100 - studentCourceDetail?.coursesPercentage) {
            return `${value}%`;
          }
          if (context.datasetIndex === 2 && value !== 100 - studentCourceDetail?.creditsPercentage) {
            return `${value}%`;
          }
          return '';
        },
      }
    },
  };
  return (
    <>
      <div className="card h-100 student_metrics">
        <a onClick={handleViewPage}>
          <div className="top">
            <div className="img">
              <img src="/assets/images/icon/book.svg" alt="" />
            </div>
            <div className="desc">
              <h2>Course Details</h2>
              <span>{studentCourceDetail?.description}</span>
            </div>
          </div>
          <div className="dtls">
            <ul className="desc">
              <li>
                <label>Semester</label>
                <h6>{studentCourceDetail?.semesterName}</h6>
              </li>
              <li>
                <label>Courses</label>
                <h6>{studentCourceDetail?.cources?.length}</h6>
              </li>
              <li>
                <label>Total Credit</label>
                <h6>{studentCourceDetail?.averageCredit}</h6>
              </li>
            </ul>
            <div className="chartWrap-new">
              <Chart
                type="doughnut"
                data={chartData}
                options={options}
                className=""
                plugins={[ChartDataLabels, centerTextPlugin]}
              />
            </div>
          </div>
        </a>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getCourceDetail: (semesterId: number) => getStudentCourceDetail(semesterId),
};

function mapStateToProps(state: any) {
  return {
    studentCourceDetail: state.studentCourceDetail.studentCourceDetail,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BetaStudentCourseDetails);
